export const entrance = {
	title: "Entradas",
	addEntrance: "Agregar entrada",
	deleteEntrance: "¿Desea eliminar la entrada {{entranceName}}?",
	table: {
		entrance: "Entrada",
		category: "Categoría",
		value: "Valor",
		consumptionObligation: "Consumo mínimo",
		minimumConsumptionValue: "Consumo anticipado",
		active: "Activo",
		variable: "Variable",
		bonus: "Bono",
		sku: "SKU",
	},
	entranceForm: {
		addEntrance: "Agregar Entrada",
		editEntrance: "Editar entrada",
		bonus: "Bono",
		details: "Información de la entrada",
		name: "Nombre",
		namePlaceHolder: "Ingrese el nombre de la entrada",
		category: "Categoría",
		categoryPlaceholder: "Seleccione la categoría de la entrada",
		price: "Precio",
		variablePrice: "Precio variable",
		consumptionObligation: "Consumo mínimo",
		minimumValueCharged: "Valor mínimo cobrado",
		minimumValueChargedTooltip:
			"El Valor mínimo cobrado es el menor valor que el cliente pagará en la cuenta y es la suma del consumo mínimo con el precio de la entrada",
		minimumConsumptionValue: "Consumo anticipado",
		image: "Foto",
		fiscalData: "Datos fiscales",
		code: "SKU",
		codePlaceholder: "Ingrese el SKU referente a la entrada",
		ncm: "NCM",
		ncmPlaceholder: "Ingrese el NCM de esta entrada",
		cest: "CEST",
		cestPlaceholder: "Ingrese el CEST de la entrada",
		fiscalProfile: "Perfil fiscal",
		fiscalProfilePlaceholder: "Seleccione el perfil fiscal de la entrada",
		fiscalGroup: "Grupo fiscal",
		fiscalGroupPlaceholder: "Seleccione el grupo fiscal de la entrada",
		newCategory: "Creará una nueva categoría",
	},
	errors: {
		mandatoryField: "Este campo es obligatorio",
		validValue: "Ingrese un valor válido",
		consumption: "No es posible registrar más de un tipo de consumo",
	},
	edit: "Editar",
	add: "Agregar",
	cancel: "Cancelar",
};
